/**
 * Histoires des compagnons — placeholder propre.
 *
 * Cette page est un emplacement réservé pour les récits de la vie des
 * compagnons (à alimenter ultérieurement avec Hayat as-Sahaba ou des
 * sources fiables équivalentes). Aucun récit n'est inventé ici.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen, Sparkles } from 'lucide-react';
import { GlassCard, SectionHeader } from '../components/shared';
import { Button } from '../components/ui/button';

export const CompanionsStories = () => {
  return (
    <div
      className="min-h-screen max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
      data-testid="companions-stories-page"
    >
      <Button
        variant="ghost"
        size="sm"
        asChild
        className="text-text-muted hover:text-text-primary mb-4"
      >
        <Link to="/companions" data-testid="companions-stories-back">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à la liste
        </Link>
      </Button>

      <SectionHeader
        overline="Compagnons"
        title="Histoires des compagnons"
        subtitle="Récits édifiants tirés de la vie des compagnons du Prophète ﷺ."
      />

      <GlassCard className="mt-6 border-amber-400/20" data-testid="companions-stories-empty">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-amber-500/15 text-amber-300 flex items-center justify-center shrink-0">
            <Sparkles className="w-4 h-4" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-serif text-text-primary">
              Section bientôt disponible
            </h3>
            <p className="text-sm text-text-secondary mt-2">
              Cette section sera enrichie prochainement avec des récits issus
              de sources fiables (Hayat as-Sahaba, Siyar Aʿlām al-Nubalā', etc.).
              En attendant, vous pouvez consulter la liste des compagnons et
              leurs profils détaillés.
            </p>
            <div className="flex flex-wrap gap-2 mt-4">
              <Button asChild size="sm" data-testid="companions-stories-go-list">
                <Link to="/companions">
                  <BookOpen className="w-3.5 h-3.5 mr-1" />
                  Voir la liste des compagnons
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </GlassCard>
    </div>
  );
};

export default CompanionsStories;
